import React, { useState, useEffect } from "react";
import AuthenticationService from "../../../Api/AuthenticationService";

const Profile = () => {
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);
    const authService = new AuthenticationService();

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await authService.getProfile();
                if (response?.data.status === "success") {
                    setProfileData(response.data.data.user);
                }
            } catch (error) {
                console.error("Error fetching profile:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);


    if (loading) {
        return <div>Loading...</div>;
    }

    if (!profileData) {
        return <div>No profile data available</div>;
    }

    return (
        <>
            <div className="content">
                <div className="section-title">
                    <h4 className="rbt-title-style-3">My Profile</h4>
                </div>
                {/* Start Profile Row  */}
                <div className="rbt-profile-row row row--15">
                    <div className="col-lg-4 col-md-4">
                        <div className="rbt-profile-content b2">Registration Date</div>
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <div className="rbt-profile-content b2">
                            {profileData.created_at ? new Date(profileData.created_at).toLocaleString() : 'N/A'}
                        </div>
                    </div>
                </div>
                {/* End Profile Row  */}
                {/* Start Profile Row  */}
                <div className="rbt-profile-row row row--15 mt--15">
                    <div className="col-lg-4 col-md-4">
                        <div className="rbt-profile-content b2">Full Name</div>
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <div className="rbt-profile-content b2">{profileData.full_name || 'N/A'}</div>
                    </div>
                </div>
                {/* End Profile Row  */}
                {/* Start Profile Row  */}
                <div className="rbt-profile-row row row--15 mt--15">
                    <div className="col-lg-4 col-md-4">
                        <div className="rbt-profile-content b2">Email</div>
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <div className="rbt-profile-content b2">{profileData.email || 'N/A'}</div>
                    </div>
                </div>
                {/* End Profile Row  */}
                {/* Start Profile Row  */}
                <div className="rbt-profile-row row row--15 mt--15">
                    <div className="col-lg-4 col-md-4">
                        <div className="rbt-profile-content b2">Phone Number</div>
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <div className="rbt-profile-content b2">{profileData.mobile_number || 'N/A'}</div>
                    </div>
                </div>
                {/* End Profile Row  */}
                {/* Start Profile Row  */}
                <div className="rbt-profile-row row row--15 mt--15">
                    <div className="col-lg-4 col-md-4">
                        <div className="rbt-profile-content b2">Role</div>
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <div className="rbt-profile-content b2">{profileData.role || 'N/A'}</div>
                    </div>
                </div>
                {/* End Profile Row  */}
                {/* Start Profile Row  */}
                <div className="rbt-profile-row row row--15 mt--15">
                    <div className="col-lg-4 col-md-4">
                        <div className="rbt-profile-content b2">Session Points</div>
                    </div>
                    <div className="col-lg-8 col-md-8">
                        <div className="rbt-profile-content b2">{profileData.session_points || 'N/A'}</div>
                    </div>
                </div>
                {/* End Profile Row  */}
            </div>
        </>
    );
};

export default Profile;
